import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { components } from "../../types/api";
import dayjs from "dayjs";

// IO consolidated margin period type
type IOMarginPeriod = components["schemas"]["IOMarginPeriod"];

interface IOMarginTableProps {
  margins: IOMarginPeriod[] | null | undefined;
  title?: string;
}

const IOMarginTable: React.FC<IOMarginTableProps> = ({ margins, title }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (!margins || margins.length === 0) {
    return (
      <Box sx={{ mt: 2, p: 3, textAlign: "center" }}>
        <Typography variant="body1">
          {t(
            "metrics.marginTable.noMargins",
            "No margin periods defined for this insertion order"
          )}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {title && (
        <Typography variant="h5" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table sx={{ minWidth: 650 }} aria-label="io margins table">
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: theme.palette.background.default,
              }}
            >
              <TableCell>
                {t("metrics.marginTable.startDate", "Start Date")}
              </TableCell>
              <TableCell>
                {t("metrics.marginTable.endDate", "End Date")}
              </TableCell>
              <TableCell align="right">
                {t("metrics.marginTable.margin", "Margin")} (%)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {margins.map((margin, index) => (
              <TableRow key={index}>
                <TableCell>
                  {dayjs(margin.startDate).format("MMM D, YYYY")}
                </TableCell>
                <TableCell>
                  {dayjs(margin.endDate).format("MMM D, YYYY")}
                </TableCell>
                <TableCell align="right">{margin.margin.toFixed(2)}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default IOMarginTable;
